/**
 * events constants
 */
export const EVENTS_LOAD_REQUESTED = 'EVENTS_LOAD_REQUESTED';
export const EVENTS_LOAD_SUCCEEDED = 'EVENTS_LOAD_SUCCEEDED';
export const EVENTS_LOAD_FAILED = 'EVENTS_LOAD_FAILED';

export const EVENTS_POLLING_REQUESTED = 'EVENTS_POLLING_REQUESTED';
export const EVENTS_POLLING_SUCCEEDED = 'EVENTS_POLLING_SUCCEEDED';
export const EVENTS_POLLING_FAILED = 'EVENTS_POLLING_FAILED';
export const EVENTS_POLLING_CANCELED = 'EVENTS_POLLING_CANCELED';

export const EVENT_LOAD_REQUESTED = 'EVENT_LOAD_REQUESTED';
export const EVENT_LOAD_SUCCEEDED = 'EVENT_LOAD_SUCCEEDED';
export const EVENT_LOAD_FAILED = 'EVENT_LOAD_FAILED';

export const EVENT_CREATE_REQUESTED = 'EVENT_CREATE_REQUESTED';
export const EVENT_CREATE_SUCCEEDED = 'EVENT_CREATE_SUCCEEDED';
export const EVENT_CREATE_FAILED = 'EVENT_CREATE_FAILED';

export const EVENT_UPDATE_REQUESTED = 'EVENT_UPDATE_REQUESTED';
export const EVENT_UPDATE_SUCCEEDED = 'EVENT_UPDATE_SUCCEEDED';
export const EVENT_UPDATE_FAILED = 'EVENT_UPDATE_FAILED';

export const EVENTS_SET = 'EVENTS_SET';
export const EVENTS_MERGE = 'EVENTS_MERGE';
export const EVENT_SET = 'EVENT_SET';
